import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, StackBlock, StatusIndicator, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useDeliveryState } from '../../../../context/CheckoutDeliveryContext';
import StoreUtil from '../../../../util/StoreUtil';
import { useAemConfig } from '@as-react/common-components';
import { storeQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { DeliveryUnit, filterScheduleEntries } from '../../../product-detail/store-finder-popup/utils';
import { DeliverySelectedLocation } from '../DeliverySelectedLocation';
import { OpeningHours } from '../../../opening-hours/OpeningHours';
import { StoreScheduleIndicator } from '../../../stores/store-schedule-indicator/StoreScheduleIndicator';
import { makeGetBasketMappedProductsState } from '../../../../redux/basket/selectors/BasketSelector';
export const CollectStoreSelected = () => {
    var _a, _b, _c, _d;
    const { defaultRequestParams, servicesEndpoint, businessUnitId, mainWebShop } = useAemConfig();
    const products = useSelector(makeGetBasketMappedProductsState());
    const { t } = useTranslation(I18N_NAMESPACES.store);
    const [{ collectStore }, dispatch] = useDeliveryState();
    const { selectedStore } = collectStore;
    const { getStoreInformation } = storeQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: storeInformation } = useQuery(getStoreInformation({
        businessUnitId,
        storeId: (selectedStore || {}).storeId,
        weeks: 2,
    }, {
        enabled: !!(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.storeId),
    }));
    if (!selectedStore)
        return null;
    const locationName = StoreUtil.getStoreName(selectedStore, mainWebShop, t);
    const address = (_a = selectedStore.address) === null || _a === void 0 ? void 0 : _a.street;
    const houseNumber = (_b = selectedStore.address) === null || _b === void 0 ? void 0 : _b.number;
    const postcode = (_c = selectedStore.address) === null || _c === void 0 ? void 0 : _c.zipCode;
    const city = (_d = selectedStore.address) === null || _d === void 0 ? void 0 : _d.city;
    const handleEditCollectStore = () => {
        dispatch({ type: 'set_open_selector', payload: 'store-finder' });
    };
    const directPickup = selectedStore.deliveryUnit === DeliveryUnit.HOURS && selectedStore.selectable;
    const isStoreEditDisabled = Boolean(products.find(product => product.sseProduct || product.specialtyStoreProduct));
    return (_jsx(DeliverySelectedLocation, { isEditDisabled: isStoreEditDisabled, locationName: locationName, addressContent: `${address} ${houseNumber}, ${postcode} ${city}`, handleEdit: handleEditCollectStore, openingHoursContent: _jsxs(Box, { children: [_jsx(StoreScheduleIndicator, { todaySchedule: selectedStore.scheduleEntries }), storeInformation && (_jsx(StackBlock, { itemsAlign: "start", children: _jsx(Box, { paddingBlockStart: "1", flex: { grow: 0 }, children: _jsx(OpeningHours, { openingHours: filterScheduleEntries(storeInformation.scheduleEntries) }) }) }))] }), additionalContent: _jsx(_Fragment, { children: directPickup ? (_jsx(StatusIndicator, { status: "complete", colored: true, children: _jsx(TextAlpha, { variant: "bodyM", children: !selectedStore.selectable
                        ? t('store.clickandcollect.noStockAvailable')
                        : selectedStore.deliveryMessage }) })) : (_jsx(StatusIndicator, { status: directPickup ? 'complete' : !selectedStore.selectable ? 'incomplete' : 'partiallyComplete', colored: directPickup, children: _jsx(TextAlpha, { variant: "bodyM", children: !selectedStore.selectable
                        ? t('store.clickandcollect.noStockAvailable')
                        : selectedStore.deliveryMessage }) })) }) }));
};
